module.exports = __webpack_public_path__ + "i18n/zh-CN.43a45234f5f366faeb0a360e6e0dab8b.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 1865
// module chunks = 0